export const poCreationAndEditGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.po_edit) return true;
  return false;
};

export const bidCreationAndEditGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.bid_edit) return true;
  return false;
};
export const fileManagerCreationAndEditGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.file_manager_edit)
    return true;
  return false;
};

export const vendorCreationAndEditGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.vendor_edit) return true;
  return false;
};

export const organisationEditGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.organisation_edit)
    return true;
  return false;
};

export const poViewGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.po_view) return true;
  return false;
};

export const bidViewGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.bid_view) return true;
  return false;
};

export const vendorViewGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.vendor_view) return true;
  return false;
};

export const fileManagerViewGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.file_manager_view)
    return true;
  return false;
};

export const organisationViewGranted = (userDetails) => {
  if (userDetails?.organisation?.user_permission?.organisation_view)
    return true;
  return false;
};
